export default "__VITE_ASSET__aohjeqVT__"